import React from "react";
import calendarIcon from "assets/products/shared/icons/calendar.svg";
import umbrellaIcon from "assets/products/shared/icons/umbrella.svg";
import moneyOffIcon from "assets/products/shared/icons/money-off.svg";

interface FinancialRealitiesProps {
    className?: string;
}

const FinancialRealities = ({ className = "" }: FinancialRealitiesProps) => {
    const iconClassName = "tablet:w-9 tablet:h-9 w-6 h-6";
    const statistics = [
        {
            icon: <img src={umbrellaIcon} alt="Umbrella icon" className={iconClassName} />,
            text: "Most workplace life insurance policies offer just a flat benefit of around $20,000—far below what most families actually need.²",
        },
        {
            icon: <img src={moneyOffIcon} alt="Vector icon" className={iconClassName} />,
            text: "63% of adults said they could cover a $400 emergency entirely with cash or equivalent methods, meaning 37% would need to borrow, sell something—or wouldn't be able to pay at all.³",
        },
        {
            icon: <img src={calendarIcon} alt="Calendar icon" className={iconClassName} />,
            text: "Almost half of American adults report that they would feel financial hardship within six months if a primary wage earner were to pass away.⁴",
        },
    ];

    return (
        <div className={`w-full py-16 bg-white tablet:px-24 px-6 ${className}`}>
            <div className="max-w-[1200px] mx-auto">
                <div className="flex flex-col lg:flex-row gap-12 items-center justify-between">
                    <div className="space-y-4 p-4 max-w-sm">
                        <h2 className="text-base-content tablet:text-5xl text-3xl tablet:font-normal font-bold text-center tablet:text-left">
                            The Financial Realities
                        </h2>
                        <div className="space-y-2">
                            <p className="text-base-content font-normal leading-relaxed text-base">
                                When a family loses a provider, the financial gap can be devastating.
                            </p>
                            <p className="text-base-content font-normal leading-relaxed text-base">
                                Many American families could face a money gap that makes it difficult to pay the mortgage or
                                rent.
                            </p>
                        </div>
                    </div>
                    <div className="flex justify-end">
                        <div className="space-y-4 max-w-md">
                            {statistics.map((stat) => (
                                <div key={stat.text} className="flex items-center space-x-4 text-base">
                                    <div className="flex-shrink-0">{stat.icon}</div>
                                    <p className="text-base-content font-normal leading-relaxed text-base">{stat.text}</p>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FinancialRealities;
